import { View } from "react-native";
import { Text, Divider } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

type Props = {
  text: string;
};

export default function InfoBanner({ text }: Props) {
  const tailwind = useTailwind();
  return (
    <View>
      <Text style={tailwind("m-5 text-center")} variant="bodyMedium">
        {text}
      </Text>

      <Divider bold />
    </View>
  );
}
